import { render, staticRenderFns } from "./GiftCards.vue?vue&type=template&id=45664aae&scoped=true&lang=html&"
import script from "./GiftCards.vue?vue&type=script&lang=js&"
export * from "./GiftCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45664aae",
  null
  
)

export default component.exports